export default "/images/0faf84bf06f5e4f38be07b4603beb650.jpg";